module.exports = __webpack_public_path__ + "img/15.0c1829d4.jpg";